<template>
  <div class="container">
    <div v-if="loading">
      <div class="kit__utils__heading text-center">
        <h5>Pricing</h5>
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="row">
          <div class="col-6">
            <div class="card">
              <a-skeleton active />
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <a-skeleton active />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="card">
              <a-skeleton active />
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <a-skeleton active />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="card">
              <a-skeleton active />
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <a-skeleton active />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!loading && !$store.state.user.isSubscribed">
      <div class="kit__utils__heading text-center">
        <h5>Pricing – 1 Year Access</h5>
      </div>
      <div class="text-center mb-4">
        Sign up now and get instant access to thousands of exam questions for 1 year.
      </div>
      <!-- <div class="d-flex flex-row justify-content-center">
        <div class="mx-3 mb-1">
          <a-radio-group v-model="term" button-style="solid">
            <a-radio-button value="monthly">
              Monthly
            </a-radio-button>
            <a-radio-button value="yearly">
              Yearly (-50%)
            </a-radio-button>
          </a-radio-group>
        </div>
      </div> -->
      <div class="d-flex flex-row justify-content-center">
        <div class="mx-3 mb-4">
          <a-radio-group v-model="currency" button-style="solid">
            <a-radio-button value="usd">
              USD
            </a-radio-button>
            <a-radio-button value="eur">
              EUR
            </a-radio-button>
            <a-radio-button value="php">
              PHP
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-lg-3 justify-content-center text-center">
          <card
            :tier="'basic'"
            :term="term"
            :currency="currency"
            :goodFeatures="goodFeatures"
            :badFeatures="badFeatures"
            :prices="prices"
            :disableButtons="disableButtons"
            @checkout="createPayment"
            @openGcash="openGcash"
          />
        </div>
        <div class="col-sm-6 col-lg-3 justify-content-center text-center">
          <card
            :tier="'plus'"
            :term="term"
            :currency="currency"
            :goodFeatures="goodFeatures"
            :badFeatures="badFeatures"
            :prices="prices"
            :disableButtons="disableButtons"
            @checkout="createPayment"
            @openGcash="openGcash"
          />
        </div>
        <div class="col-sm-6 col-lg-3 justify-content-center text-center">
          <card
            :tier="'pro'"
            :term="term"
            :currency="currency"
            :goodFeatures="goodFeatures"
            :badFeatures="badFeatures"
            :prices="prices"
            :disableButtons="disableButtons"
            @checkout="createPayment"
            @openGcash="openGcash"
          />
        </div>
        <div class="col-sm-6 col-lg-3 justify-content-center text-center">
          <card
            :tier="'unlimited'"
            :term="term"
            :currency="currency"
            :goodFeatures="goodFeatures"
            :badFeatures="badFeatures"
            :prices="prices"
            :disableButtons="disableButtons"
            @checkout="createPayment"
            @openGcash="openGcash"
          />
        </div>
      </div>
      <div class="row justify-content-center text-center mt-2 mb-4 mx-2">
        <strong>Tip: Choose an annual plan for a higher discount!</strong>
      </div>
      <div id="gcash" ref="gcash" class="row justify-content-center text-center mt-3 mb-4" v-if="currency==='php'">
        * GCash processing time: up to 24 hours.<br>
        Pay by card for Instant Access!
      </div>
      <div class="row justify-content-center" v-if="showGcash && currency==='php'">
        <div class="pricing card-deck flex-column flex-lg-row mb-3">
          <gcash :gcashPrice="gcashPrice" />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <h3>You are already subscribed.</h3>
      </div>
      <div class="row justify-content-center">
        <redirect :redirectPath="'/dashboard/alpha'" />
      </div>
    </div>
  </div>
</template>

<script>
import card from '@/components/pricing/card'
import gcash from '@/components/pricing/gcash'
import * as firebase from '@/services/firebase'
import { mapState } from 'vuex'
import { loadStripe } from '@stripe/stripe-js'
import redirect from '@/components/redirect'

const stripeInit = loadStripe('pk_live_51HIsyRIvFnhTukDrPYT9UsRdKDREDf8y8v4WQjlSI01ZK7qKMiXV1enJO54yb7JFqDofymHxtYxEh0nn7ANoqMbd00AIoJeCRC')

export default {
  components: {
    card,
    gcash,
    redirect,
  },
  data() {
    return {
      showGcash: false,
      gcashPrice: 256,
      disableButtons: false,
      paymentId: '',
      payment: {},
      payments: [],
      session: {},
      tier: 'pro',
      term: 'yearly',
      currency: 'php',
      pricingIcon: 'fe fe-inbox font-size-40 mb-3 d-block',
      prices: {
        basic: {
          eur: {
            symbol: '€',
            monthly: 6.5,
            monthlyDisc: 5.2,
            yearly: 78,
            yearlyDisc: 39,
          },
          usd: {
            symbol: '$',
            monthly: 6.5,
            monthlyDisc: 5.2,
            yearly: 78,
            yearlyDisc: 39,
          },
          php: {
            symbol: 'P',
            monthly: 320,
            monthlyDisc: 256,
            yearly: 3840,
            yearlyDisc: 1920,
          },
        },
        plus: {
          eur: {
            symbol: '€',
            monthly: 6.5,
            monthlyDisc: 5.2,
            yearly: 52,
            yearlyDisc: 26,
          },
          usd: {
            symbol: '$',
            monthly: 6.5,
            monthlyDisc: 5.2,
            yearly: 60,
            yearlyDisc: 30,
          },
          php: {
            symbol: 'P',
            monthly: 320,
            monthlyDisc: 256,
            yearly: 3000,
            yearlyDisc: 1500,
          },
        },
        pro: {
          eur: {
            symbol: '€',
            monthly: 5,
            monthlyDisc: 4,
            yearly: 88,
            yearlyDisc: 44,
          },
          usd: {
            symbol: '$',
            monthly: 6,
            monthlyDisc: 5,
            yearly: 100,
            yearlyDisc: 50,
          },
          php: {
            symbol: 'P',
            monthly: 320,
            monthlyDisc: 250,
            yearly: 5000,
            yearlyDisc: 2500,
          },
        },
        unlimited: {
          eur: {
            symbol: '€',
            monthly: 10,
            monthlyDisc: 8,
            yearly: 140,
            yearlyDisc: 70,
          },
          usd: {
            symbol: '$',
            monthly: 12,
            monthlyDisc: 10,
            yearly: 160,
            yearlyDisc: 80,
          },
          php: {
            symbol: 'P',
            monthly: 640,
            monthlyDisc: 500,
            yearly: 7800,
            yearlyDisc: 3900,
          },
        },
      },
      goodFeatures: {
        basic: [
          '100 questions',
          'Free forever',
          '1 device',
          'Progress dashboard',
          'Basic support',
        ],
        plus: [
          '2,000 questions',
          '1 year access',
          '1 device',
          'Progress dashboard',
          'Basic support',
        ],
        pro: [
          '5,000 questions',
          '1 year access',
          '2 devices',
          'Progress dashboard',
          'Premium support',
          'Custom lists',
          'Practice tests',
        ],
        unlimited: [
          '10,000+ questions',
          '1 year access',
          'Unlimited devices',
          'Progress dashboard',
          'Premium support',
          'Custom lists',
          'Practice tests',
        ],
      },
      badFeatures: {
        basic: [
          'No custom lists',
          'No practice test',
        ],
        plus: [
          'No custom lists',
          'No practice tests',
        ],
        pro: [
        ],
        unlimited: [
        ],
      },
      products: {
        plus: {
          monthly: {
            eur: 'price_1IVMUaIvFnhTukDrbcvi858Q',
            usd: 'price_1IVMUaIvFnhTukDrTL6aSHLp',
            php: 'price_1IVMUaIvFnhTukDr2dw3J78m',
          },
          yearly: {
            eur: 'price_1IcFeNIvFnhTukDrTwlx4xU0',
            usd: 'price_1IcFeCIvFnhTukDrHaRxhbA0',
            php: 'price_1IcFdgIvFnhTukDrvUujIeYv',
          },
        },
        pro: {
          monthly: {
            eur: 'price_1IZ0suIvFnhTukDrVRKicJwF',
            usd: 'price_1IZ0t2IvFnhTukDrrtAcS6Ps',
            php: 'price_1IZ0tPIvFnhTukDrpWTPUZhY',
          },
          yearly: {
            eur: 'price_1IcFaJIvFnhTukDrUbnrtIsC',
            usd: 'price_1IcFa5IvFnhTukDrJZG1uy8g',
            php: 'price_1IcFZOIvFnhTukDrOolzpP6t',
          },
        },
        unlimited: {
          monthly: {
            eur: 'price_1IZ0oEIvFnhTukDrgsriHKIo',
            usd: 'price_1IZ0ntIvFnhTukDrfwdd9Di4',
            php: 'price_1IZ0oXIvFnhTukDrODxyQjda',
          },
          yearly: {
            eur: 'price_1IcFXWIvFnhTukDrSOBJCjFD',
            usd: 'price_1IcFXkIvFnhTukDrzuyRgK5y',
            php: 'price_1IcFWbIvFnhTukDrhmCHepQn',
          },
        },
      },
    }
  },
  mounted: function() {
    setTimeout(() => this.scrollFix(this.$route.hash), 1)
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
  computed: {
    ...mapState(['user']),
    loading() {
      return this.$store.state.user.loading
    },
    // lineItems() {
    //   return {
    //     price: this.products[this.tier][this.term][this.currency],
    //     quantity: 1,
    //     tier: this.tier,
    //   }
    // },
  },
  methods: {
    scrollFix: function(hashbang) {
      location.hash = hashbang
    },

    async createPayment(tier, term, currency) {
      this.disableButtons = true
      this.tier = tier
      this.paymentId = this.generateId()
      console.log(tier + term + currency)
      console.log('paymentId: ' + this.paymentId)
      await firebase.firebaseFirestore
        .collection('stripe_customers')
        .doc(this.$store.state.user.id)
        .collection('payments')
        .doc(this.paymentId)
        .set({
          price: this.products[tier][term][currency],
          quantity: 1,
          tier: tier,
        })
        .catch(err => console.log(err))
      this.listenForSessionId()
    },

    openGcash(tier, term, currency) {
      this.gcashPrice = this.prices[tier][currency][term + 'Disc']
      this.disableButtons = true
      this.showGcash = true
      this.scrollMeTo('gcash')
    },

    scrollMeTo(refName) {
      var element = this.$refs[refName]
      element.scrollIntoView({ behavior: 'smooth' })
    },

    generateId() {
      return 'p' + Math.floor(Math.random() * (99999999999 - 10000000000 + 1) + 10000000000).toString()
    },

    async listenForSessionId() {
      await firebase.firebaseFirestore
        .collection('stripe_customers')
        .doc(this.$store.state.user.id)
        .collection('payments')
        .doc(this.paymentId)
        .onSnapshot((doc) => {
          this.payment = doc.data()
          console.log(doc.data())
        })
    },

    async redirectToCheckout() {
      await this.payment.id
      stripeInit
        .then(stripe => {
          stripe.redirectToCheckout({
            sessionId: this.payment.id,
          }).then(() => {
            console.log('Redirecting to Stripe')
          }).catch(err => {
            console.log(err)
          })
        })
    },
  },

  watch: {
    payment: function () {
      if (this.payment.id) {
        console.log('Checkout Session ID: ', this.payment.id)
        this.redirectToCheckout()
      }
    },
  },
}
</script>
